import React from "react";
import C from "action-types";
import { post } from "utils/api";
import { errorMessage, message } from "actions/message";

const isImporterHistoryUrl = url =>
  typeof url === "string" && /\/history\/\d+$/.test(url);

const buildV2Message = (text, url) => {
  if (isImporterHistoryUrl(url)) {
    return (
      <span>
        {text}{" "}
        <a href={url} target="_blank" rel="noopener noreferrer">
          View import history
        </a>
      </span>
    );
  }
  return text;
};

export const submitPatientImport = data => {
  return {
    type: C.PATIENT.PATIENT_IMPORT,
    payload: data
  }
};

export const initiatePatientImport = (requestorMGUID, companyMGUID) => async (dispatch)  => {
  try {
    const response = await post(`Niko/Import/${requestorMGUID}/${companyMGUID}`);
    if (response === "Import Completed Successfully") {
      dispatch(message(response));
    } else {
      dispatch(errorMessage(response));
    }
  } catch (error) {
    dispatch(errorMessage(`Niko Import failed, ${error}`));
  }
}

export const initiateAccountImport = (requestorMGUID, companyMGUID, accountNumber) => async (dispatch)  => {
  try {
    const response = await post(`Niko/Import/${requestorMGUID}/${companyMGUID}/${accountNumber}`);
    if (response === "Import Completed Successfully") {
      dispatch(message(response));
    } else {
      dispatch(errorMessage(response));
    }
  } catch (error) {
    dispatch(errorMessage(`Niko Import failed, ${error}`));
  }
}

// V2 — single patient import (called from patient-import.jsx)
export const initiateAccountImportV2 = (companyGUID, accountNumber) => async dispatch => {
  try {
    const response = await post(`NikoV2/Import/${companyGUID}/${accountNumber}`);
    if (response.Success) {
      dispatch(message(buildV2Message("Import submitted successfully.", response.ImporterHistoryUrl), -1));
    } else {
      dispatch(errorMessage(buildV2Message(response.ErrorMessage || "Niko V2 import failed", response.ImporterHistoryUrl), -1));
    }
    return response;
  } catch (error) {
    dispatch(errorMessage(`Niko V2 import failed: ${error}`));
  }
};

// V2 — full company import (manual trigger)
// Response is NikoV2DailyRunResult: { Import, Tracking, Status }
export const initiatePatientImportV2 = (companyGUID) => async dispatch => {
  try {
    const response = await post(`NikoV2/Import/${companyGUID}`);
    const { Import: importResult, Tracking: trackingResult, Status: statusResult } = response;
    const historyUrl = importResult?.ImporterHistoryUrl;
    const failures = [importResult, trackingResult, statusResult]
      .filter(r => r && !r.Success)
      .map(r => r.ErrorMessage)
      .filter(Boolean);

    if (failures.length === 0) {
      dispatch(message(buildV2Message("Import completed successfully.", historyUrl), -1));
    } else {
      dispatch(errorMessage(buildV2Message(failures.join("; ") || "Niko V2 import failed", historyUrl), -1));
    }
    return response;
  } catch (error) {
    dispatch(errorMessage(`Niko V2 import failed: ${error}`));
  }
};